import { render, staticRenderFns } from "./add-sale-admin-royalty-free-popup.vue?vue&type=template&id=12992410"
import script from "./add-sale-admin-royalty-free-popup.vue?vue&type=script&lang=js"
export * from "./add-sale-admin-royalty-free-popup.vue?vue&type=script&lang=js"
import style0 from "./add-sale-admin-royalty-free-popup.vue?vue&type=style&index=0&id=12992410&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports